import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-typologies',
  storeModule.createStoreModule('real-estate-developments-typologies')
)
